export default `
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css");
:host {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 16px;
}
:host * {
  box-sizing: border-box;
}
:host > button {
  padding: 0.5rem;
  border-radius: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  transition: all 150ms ease;
  background-color: #7286d3;
  color: white;
  height: 4rem;
  width: 4rem;
  position: fixed;
  right: 2rem;
  box-shadow: 12px 12px 16px 0 rgba(0, 0, 0, 0.25), -8px -8px 12px 0 rgba(255, 255, 255, 0.3);
}
:host > button i.emoji-icon {
  font-style: normal !important;
  line-height: 3rem;
  width: 33px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -2px;
}
@media screen and (min-width: 768px) {
  :host > button {
    top: calc(100vh - 6rem);
  }
}
@media screen and (max-width: 767px) {
  :host > button {
    top: 2rem;
  }
}
:host > button:hover {
  transform: scale(1.1);
  cursor: pointer;
}
:host > button:active {
  transform: scale(1.2);
}
:host > button i {
  font-size: 2rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
